import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { LoggingService, LogLevel } from '@app/services/logging.service';

@Injectable()
export class PwaLogUpdateService {
  static readonly COMPONENT_NAME = 'PwaLogUpdateService';

  constructor(private updates: SwUpdate, private loggingService: LoggingService) {
  }

  init() {
    this.updates.versionUpdates.subscribe(evt => {
      switch (evt.type) {
        case 'VERSION_DETECTED':
          this.loggingService.log(LogLevel.DEBUG, PwaLogUpdateService.COMPONENT_NAME, `[PWA]: Downloading new app version: ${evt.version.hash}`);
          break;
        case 'VERSION_READY':
          this.loggingService.log(LogLevel.DEBUG, PwaLogUpdateService.COMPONENT_NAME, `[PWA]: Current app version: ${evt.currentVersion.hash}`);
          this.loggingService.log(LogLevel.DEBUG, PwaLogUpdateService.COMPONENT_NAME, `[PWA]: New app version ready for use: ${evt.latestVersion.hash}`);
          break;
        case 'VERSION_INSTALLATION_FAILED':
          this.loggingService.log(LogLevel.ERROR, PwaLogUpdateService.COMPONENT_NAME, `[PWA]: Failed to install app version '${evt.version.hash}': ${evt.error}`);
          break;
      }
    });

    this.loggingService.log(LogLevel.DEBUG, PwaLogUpdateService.COMPONENT_NAME, `[PWA]: Initialized PwaLogUpdateService`);

  }

}
